module.exports = __webpack_public_path__ + "img/vote-icon.cb5b96f9.svg";